
export default {
    taxcodeList: [],
    taxcodeListMeta: {
        total: 0,
        currentPage: "1",
        perPage: "10",
    },
    currentTaxcodeObject:{}
};
